export default __webpack_public_path__ + "css/productDetails.bundle.css";